import GlassCard from '../../GlassCard';
import SectionHeader from '../../ui/SectionHeader';
import JobSearchBanner from './JobSearchBanner';
// import ContactForm from './ContactForm';
import ContactMethods from './ContactMethods';

export default function Contact() {
  return (
    <section id="contact" className="min-h-screen flex items-center justify-center px-4 py-20">
      <div className="max-w-4xl w-full">
        <GlassCard className="border-emerald-400/30">
          <SectionHeader title="Get In Touch" />
          <JobSearchBanner />
          {/* <ContactForm /> */}
          <ContactMethods />
        </GlassCard>
      </div>
    </section>
  );
}